export class QuoteRoutes {
  public static ROUTES = {
    Login: {
      path: 'login',
      fullPath: 'login',
    },
    RequestResetPassword: {
      path: 'request-reset-password',
      fullPath: 'request-reset-password/',
    },
    ResetPassword: {
      path: 'reset-password/token/:id',
      fullPath: 'reset-password/token/',
    },
    Home: {
      path: 'home',
      fullPath: 'quote/home',
    },
    Quote: {
      path: 'quote',
      fullPath: 'quote',
    },
    StepsPath: {
      path: 'steps',
      fullPath: 'quote/steps',
    },
    Steps: {
      StepMainData: {
        code: 'SMD',
        path: 'steps/main-data',
        fullPath: 'quote/steps/main-data',
        index: 0,
        isComplete: false,
        img: '/assets/img/svg/main-data-icon-blue.svg',
      },
      StepPremisesData: {
        code: 'SPD',
        path: 'steps/premises-data',
        fullPath: 'quote/steps/premises-data',
        index: 1,
        isComplete: false,
        img: '/assets/img/svg/premises-data-icon-blue.svg',
      },
      StepPricing: {
        code: 'STP',
        path: 'steps/pricing',
        fullPath: 'quote/steps/pricing',
        index: 2,
        isComplete: false,
        img: '/assets/img/svg/pricing-icon-blue.svg',
      },
      StepCheckout: {
        code: 'STC',
        path: 'steps/checkout',
        fullPath: 'quote/steps/checkout',
        index: 3,
        isComplete: false,
        img: '/assets/img/svg/checkout-icon-blue.svg',
      },
      StepEndQuote: {
        code: 'SEQ',
        path: 'steps/end-quote',
        fullPath: 'quote/steps/end-quote',
        index: 4,
      },
    },
    QuoteError: {
      code: 'RE',
      path: 'error',
      fullPath: 'quote/error',
    },
    PreviousQuotes: {
      path: 'previous-quotes',
      fullPath: 'quote/previous-quotes',
    },
    PoliciesSold: {
      path: 'policies-sold',
      fullPath: 'quote/policies-sold',
    },
    PolicySold: {
      path: 'policies-sold/:id',
      fullPath: 'quote/policies-sold/',
    },
    ContactUs: {
      path: 'contact-us',
      fullPath: 'quote/contact-us',
    },
    BrokerManagement: {
      path: 'broker-management',
      fullPath: 'quote/broker-management',
    },
  };
}
